import { render, staticRenderFns } from "./TheLayoutWrap.vue?vue&type=template&id=4094a17a&scoped=true&"
import script from "./TheLayoutWrap.vue?vue&type=script&lang=js&"
export * from "./TheLayoutWrap.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutWrap.vue?vue&type=style&index=0&id=4094a17a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094a17a",
  null
  
)

export default component.exports